/* jshint browser:true */

/**
 * Utilities to assist with performance.
 */
export default class PerfUtils {
  /**
   * Returns a function that once called, cannot be called again until a
   * specified amount of time has passed.
   * @param {Function} func The function to debounce.
   * @param {number} wait The number of milliseconds to wait.
   * @param {boolean} runNow Whether to run the function now or wait until the
   *        first wait period has passed.
   */
  static debounce(func, wait, runNow = false) {
    let timeout;

    return () => {
      const laterFunc = () => {
        timeout = null;

        if (!runNow) {
          func.apply(this, arguments);
        }
      };

      const readyNow = runNow && !timeout;

      clearTimeout(timeout);

      timeout = setTimeout(laterFunc, wait);

      if (readyNow) {
        func.apply(this, arguments);
      }
    };
  }
}
